export default __webpack_public_path__ + "static/media/python.82efb64f.png";